import {Col, Form, InputNumber, Row, Select} from 'antd';
import React, {useContext, useEffect} from 'react';
import WangEditor from '../common/WangEditor';
import {sideMenuContext} from '../../../router/IndexRouter';
import AddFormComponent from '../common/AddFormComponent';
import EditFormComponent from '../common/EditFormComponent';
import {Arguments} from '../common/Arguments';
import SaveButtonComponent from '../common/SaveButtonComponent';
import {validateEditorContent} from '../common/ValidateWhiteSpace';

const layout = {
	labelCol: {span: 8},
	wrapperCol: {span: 16},
};

const tailLayout = {
	wrapperCol: {offset: 4, span: 16},
};

const formRef = React.createRef();

const AddEvaluateInformation = () => {
	const currentUrl = window.location.href;
	// 获取 WangEditor 中的数据
	const {editorContent} = useContext(sideMenuContext);
	const apiList = [Arguments.host + '/society_organization/base/branch/api!addEvaluateInformation.do'];

	useEffect(() => {
		formRef.current.setFieldsValue({
			checkContent: editorContent,
		});
	}, [editorContent]);

	return (currentUrl.endsWith('add') ? <AddFormComponent UserForm={EvaluateInformationForm} url={apiList}/>
		: <EditFormComponent UserForm={EvaluateInformationForm} url={apiList}/>);
};

const EvaluateInformationForm = ({onFinish, initialValues}) => {
	const [form] = Form.useForm();

	return (
		<Form
			{...layout}
			form={form}
			name="control-hooks"
			onFinish={onFinish}
			initialValues={initialValues}
			style={{maxWidth: 1200, marginLeft: 40}}
			ref={formRef}
		>
			<Row align="top">
				<Col span={12}>
					<Form.Item name="year" label="考评年度" rules={[{required: true, message: '内容不能为空'}]}>
						<InputNumber style={{width: 150}} min={0}/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="checkResult" label="考评结果" rules={[{required: true, message: '内容不能为空'}]}
							   initialValue="优秀">
						<Select>
							<Select.Option value="优秀">优秀</Select.Option>
							<Select.Option value="良好">良好</Select.Option>
							<Select.Option value="合格">合格</Select.Option>
							<Select.Option value="不合格">不合格</Select.Option>
							<Select.Option value="未参加">未参加</Select.Option>
						</Select>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="checkContent" label="考评说明"
						rules={[{required: true, validator: validateEditorContent}]}>
						<WangEditor defaultValue={initialValues?.checkContent}/>
					</Form.Item>
				</Col>
			</Row>

			<Form.Item {...tailLayout}>
				<SaveButtonComponent/>
			</Form.Item>
		</Form>
	);
};

export default AddEvaluateInformation;

